export { default } from './Browser';


// WEBPACK FOOTER //
// ./src/components/Browser/index.js